import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded'
import Box from '@mui/joy/Box'
import CircularProgress from '@mui/joy/CircularProgress'
import Typography from '@mui/joy/Typography'

import type { CheckoutSuccessStateVariant } from './view-model'

function getStateIcon(variant: CheckoutSuccessStateVariant) {
    if (variant === 'pending') {
        return <HourglassTopRoundedIcon sx={{ fontSize: 64 }} />
    }

    if (variant === 'successful') {
        return <CheckCircleRoundedIcon sx={{ fontSize: 64 }} />
    }

    return <ErrorOutlineRoundedIcon sx={{ fontSize: 64 }} />
}

export function CheckoutSuccessLoadingState() {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#F7F7F7',
            }}
        >
            <CircularProgress />
        </Box>
    )
}

export function CheckoutSuccessStateCard({
    variant,
    title,
    text,
    actionHref,
    actionLabel,
}: {
    variant: CheckoutSuccessStateVariant
    title: string
    text: string
    actionHref: string
    actionLabel: string
}) {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#F7F7F7',
                px: 2,
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 520,
                    backgroundColor: 'white',
                    borderRadius: '18px',
                    p: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                    textAlign: 'center',
                }}
            >
                <Box sx={{ color: 'customBlack.main', display: 'flex' }}>
                    {getStateIcon(variant)}
                </Box>
                <Typography level="h3">{title}</Typography>
                <Typography sx={{ color: '#484848' }}>{text}</Typography>
                <Box
                    component="a"
                    href={actionHref}
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 1,
                        fontSize: '15px',
                        padding: '0.875rem 1.25rem',
                        borderRadius: '7px',
                        backgroundColor: 'customBlack.main',
                        color: 'common.white',
                        textDecoration: 'none',
                    }}
                >
                    {actionLabel}
                </Box>
            </Box>
        </Box>
    )
}
